/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {formatLocaleNumber} from '../locale/locale-number-format';

export function formatPercentage(input: any, decimals?: number, blockNegative?: boolean, locale = 'en'): string {
  const percentageNumber = input * 100;
  if (!_.isFinite(percentageNumber) || (blockNegative && percentageNumber < 0)) {
    return '-';
  }
  const maxDigits = _.isFinite(decimals) ? decimals : 0;
  return formatLocaleNumber(percentageNumber, `1.0-${maxDigits}`, locale) + '%';
}
